<script lang="ts">
    import { onDestroy } from "svelte";
    import { Badge, Icon } from "sveltestrap";
    import type { Color } from "sveltestrap/src/shared";
    import type { Fn } from "../global";
    import type { FormInstance } from "../Model/FormInstance";
    import { readableFrom } from "../Services";

    export let instance: FormInstance;

    let unsubscribe: Fn;
    let icon = '';
    let text = '';
    let color: Color = 'success';
    
    $: setupInstance(instance);
    
    onDestroy(() => unsubscribe());

    function setupInstance(instance: FormInstance): void {
        unsubscribe?.();
        unsubscribe = readableFrom([
            instance.isFinishedReadable,
            instance.isSignedReadable,
        ]).subscribe(updateComponent);
    }

    function updateComponent(): void {
        if (instance.isFinished) {
            text = 'Finalizado';
            color = 'success';
            icon = 'patch-check-fill';
            return;
        }
        const { members } = instance;
        const numSignatures = members.reduce((a, { isSigned }) => isSigned ? a + 1 : a, 0);
        text = `${numSignatures} / ${members.length}`;
        color = instance.isFullSigned ? 'primary' : 'secondary';
        icon = 'patch-check';
    }

</script>

<Badge {color} pill>
    <Icon name={icon} /> {text}
</Badge>